import { Link, useLocation } from 'react-router-dom'
import '../styles/legal.css'

export default function Legal() {
  const location = useLocation()
  const isTerms = location.pathname.includes('terms')

  return (
    <div className="page container legal-page">
      <div className="legal-card card card-pad">
        <div className="legal-head">
          <Link to="/" className="back-link">
            ← На главную
          </Link>
          <h1>{isTerms ? 'Пользовательское соглашение' : 'Политика конфиденциальности'}</h1>
          <p className="tiny muted">Последнее обновление: 2026 г.</p>
        </div>

        {isTerms ? (
          <div className="legal-content">
            <section>
              <h2>1. Общие положения</h2>
              <p>
                1.1. Настоящее Пользовательское соглашение регулирует порядок использования сервиса CaseMania
                и определяет права и обязанности Пользователя и Администрации сервиса.
              </p>
              <p>
                1.2. Использование сервиса допускается исключительно лицами, достигшими возраста 18 лет.
                Авторизуясь через Steam, Пользователь подтверждает своё совершеннолетие.
              </p>
            </section>

            <section>
              <h2>2. Предмет соглашения</h2>
              <p>
                2.1. Сервис предоставляет Пользователю доступ к интерактивным игровым механикам (открытие кейсов,
                апгрейды, контракты обмена) с виртуальными предметами игры Counter-Strike 2.
              </p>
              <p>
                2.2. CaseMania не является азартной игрой, не проводит лотерей и не связана с Valve Corporation.
              </p>
            </section>

            <section>
              <h2>3. Права и обязанности</h2>
              <p>
                3.1. Пользователь обязуется не использовать ошибки сайта (баги), сторонний софт для автоматизации
                или попытки вмешательства в работу сервиса.
              </p>
              <p>
                3.2. Администрация оставляет за собой право блокировать аккаунты, уличённые в нарушении правил.
              </p>
            </section>
          </div>
        ) : (
          <div className="legal-content">
            <section>
              <h2>1. Сбор информации</h2>
              <p>
                1.1. Сервис обрабатывает публичные данные аккаунта Steam (SteamID, имя профиля, аватар) для
                идентификации Пользователя и обеспечения работы функций сайта.
              </p>
            </section>

            <section>
              <h2>2. Использование данных</h2>
              <p>
                2.1. Мы не передаём личные данные третьим лицам, за исключением случаев, предусмотренных
                законодательством.
              </p>
              <p>
                2.2. Сервис использует файлы cookie для сохранения сессии авторизации Пользователя.
              </p>
            </section>

            <section>
              <h2>3. Безопасность</h2>
              <p>
                3.1. Все соединения с сервисом защищены сквозным шифрованием по протоколу SSL/TLS.
              </p>
            </section>
          </div>
        )}
      </div>
    </div>
  )
}
